import api from './apiClient';
import i18n from '../i18n';

const SUPPORTED = ['ru', 'en', 'zh'];
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const applyUserLanguage = (language) => {
  if (!language || !SUPPORTED.includes(language)) return false;
  if (i18n.language === language) return true;
  i18n.changeLanguage(language);
  return true;
};

export const saveLanguageToProfile = async (userId, language) => {
  if (!userId || !language || !SUPPORTED.includes(language)) return false;
  try {
    await api.post(`${API_BASE_URL}profile/edit/${userId}`, { language });
    return true;
  } catch (e) {
    return false;
  }
};
